import React, { useEffect, useState } from 'react';
import { stopBackgroundScrolling } from '../../../common/utils/app.utils';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { faOnDedicatedNeedAssistancePopupLoad, faOnDedicatedNeedAssistancePopupSubmit } from '../../services/analytics.service';
import { checkIfObjectHasValue } from 'common/utils/app.utils';

const NeedAssistantPopup = ({ setRemarksValue, remarksValue, submitAddDiConnectionDetails, closeNeedAssistantPopup, btnDisabled, customerDetail }) => {
  const kamDetails = customerDetail && customerDetail.kamDetails ? customerDetail.kamDetails : {};
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    faOnDedicatedNeedAssistancePopupLoad();
  }, []);
  const closeNeedAssistant = () => {
    stopBackgroundScrolling(false);
    closeNeedAssistantPopup();
    setRemarksValue('');
    setIsLoading(false);
  };
  const submitNeedAssistantPopup = () => {
    if (remarksValue) {
      setIsLoading(true);
      submitAddDiConnectionDetails(closeNeedAssistant);
    }
    faOnDedicatedNeedAssistancePopupSubmit({ remarks: remarksValue });
  };

  return (
    <div className="drawerSection drawerSectionShow">
      <div className="popup-section cancelOrder">
        <h2>Contact Key Account Manager</h2>
        <p>
          Please share your reason below for assistance from your key account manager {checkIfObjectHasValue(kamDetails) ? ':' : ''}{' '}
          {kamDetails?.firstName ? kamDetails?.firstName + ' (' : ''}
          <a className="assistance_link" href={'mailto: ' + kamDetails?.email}>
            {kamDetails?.email ? kamDetails.email + ',' : ''}
          </a>{' '}
          {kamDetails?.phoneNumber}
          {checkIfObjectHasValue(kamDetails) ? ')' : ''}
        </p>
        <TextArea name="remarks" label="Reason for assistance." placeholder="Enter Description" required onChange={setRemarksValue} value={remarksValue} maxLength={150} />
        <div className="character">
          {/*<span>0/</span>150*/}
          <span>&nbsp;</span>
        </div>
        {btnDisabled ? (
          <div className="buttonSection">
            <button type="button" className="btn activebtn disabled">
              Cancel
            </button>
            <button type="button" className={`btn btn-transparent activebtn disabled}`}>
              Submit
            </button>
          </div>
        ) : (
          <div className="buttonSection">
            <button type="button" className="btn activebtn" onClick={closeNeedAssistant}>
              Cancel
            </button>
            <button type="button" className={`btn btn-transparent activebtn ${remarksValue && !isLoading ? '' : 'disabled'}`} onClick={submitNeedAssistantPopup}>
              Submit
              {isLoading && <span className="loading_icon"></span>}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default NeedAssistantPopup;
